"use client";

import { Language } from "@/types/weather";

interface FooterProps {
  lang: Language;
}

export default function Footer({ lang }: FooterProps) {
  return (
    <footer className="border-t border-white/5 mt-16">
      <div className="container mx-auto px-4 py-6 text-center">
        <p className="text-slate-500 text-sm">
          {lang === "ja" ? "天気データ提供: " : "Weather data provided by "}
          <a
            href="https://open-meteo.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300 transition-colors"
          >
            Open-Meteo
          </a>
          {lang === "ja"
            ? " · オープンソース気象API · 非商用利用無料"
            : " · Open-source weather API · Free for non-commercial use"}
        </p>
        <p className="text-slate-600 text-xs mt-2">
          © {new Date().getFullYear()} irigon weather
        </p>
      </div>
    </footer>
  );
}
